export const SERIES_TOKENS = ['series1', 'series2', 'series3', 'series4', 'series5', 'series6'] as const;

type SeriesToken = (typeof SERIES_TOKENS)[number] | 'seriesOther';

const OTHER_SERIES_KEY = 'other';

const seriesTokenAt = (index: number): SeriesToken => SERIES_TOKENS[index] ?? 'seriesOther';

export const seriesColorOf = (key: string, index: number): string =>
  key === OTHER_SERIES_KEY ? 'var(--color-seriesOther)' : `var(--color-${seriesTokenAt(index)})`;
